import { Spin, Typography } from "@timeedit/ui-components";

const defaultTranslations = {
  registrationLoadingLine1: "Loading your modules...",
  registrationLoadingLine2:
    "This might take some time, please do not reload the page.",
} as const;

interface Props {
  translations?: Record<keyof typeof defaultTranslations, string> &
    Record<string, string>;
}

export function RegistrationLoadingSpinner({
  translations = defaultTranslations,
}: Props): React.JSX.Element {
  return (
    <Spin
      size="large"
      center
      description={
        <Typography.Text className="tw:block tw:text-center">
          {translations.registrationLoadingLine1}
          <br />
          {translations.registrationLoadingLine2}
        </Typography.Text>
      }
    />
  );
}
